export const navLinks = [
  { id: "home", label: "首页" },
  { id: "entrance", label: "访问入口" },
  { id: "intro", label: "平台介绍" },
  { id: "category", label: "漫画分类" },
  { id: "popular", label: "热门推荐" },
  { id: "guide", label: "打开指南" },
  { id: "faq", label: "常见问题" },
];

export const entranceItems = [
  {
    name: "官方主站",
    domain: "www.xukongmhw.com",
    note: "日常阅读推荐，访问稳定流畅",
    tag: "推荐",
    level: "primary",
    icon: "ri-command-line",
  },
  {
    name: "备用入口 A",
    domain: "v2.xukongmhw.com",
    note: "主站访问人数较多时的备用通道",
    tag: "备用",
    level: "accent",
    icon: "ri-swap-box-line",
  },
  {
    name: "备用入口 B",
    domain: "mirror.xukongmhw.com",
    note: "主站与入口 A 均无法打开时使用",
    tag: "备用",
    level: "secondary",
    icon: "ri-route-line",
  },
  {
    name: "手机版",
    domain: "m.xukongmhw.com",
    note: "手机浏览器直接访问，自动适配屏幕",
    tag: "移动端",
    level: "secondary",
    icon: "ri-smartphone-line",
  },
];

export const stats = [
  { value: "1.2w+", label: "连载漫画" },
  { value: "500+", label: "每日更新" },
  { value: "680w+", label: "注册读者" },
  { value: "98.6%", label: "读者好评率" },
];

export const categories = [
  {
    icon: "ri-fire-line",
    name: "热血动作",
    desc: "拳拳到肉的战斗与燃烧的斗志",
    count: "2,180",
    tone: "primary",
  },
  {
    icon: "ri-compass-3-line",
    name: "奇幻冒险",
    desc: "未知大陆与异世界的神秘旅程",
    count: "1,864",
    tone: "accent",
  },
  {
    icon: "ri-flashlight-line",
    name: "都市异能",
    desc: "都市日常与隐藏能力的碰撞",
    count: "1,326",
    tone: "secondary",
  },
  {
    icon: "ri-focus-3-line",
    name: "悬疑推理",
    desc: "层层谜团与反转烧脑的真相",
    count: "978",
    tone: "primary",
  },
  {
    icon: "ri-heart-3-line",
    name: "恋爱治愈",
    desc: "暖心日常与甜而不腻的悸动",
    count: "1,540",
    tone: "accent",
  },
  {
    icon: "ri-rocket-2-line",
    name: "科幻机甲",
    desc: "未来纪元与巨型机甲的战争",
    count: "1,052",
    tone: "secondary",
  },
  {
    icon: "ri-sparkling-2-line",
    name: "穿越异界",
    desc: "意外降临，从零开始的冒险",
    count: "1,703",
    tone: "primary",
  },
  {
    icon: "ri-emotion-laugh-line",
    name: "轻松搞笑",
    desc: "脑洞大开、笑点密集的日常",
    count: "2,096",
    tone: "accent",
  },
];

export const popularComics = [
  {
    cover:
      "https://readdy.ai/api/search-image?query=anime%20manga%20comic%20book%20cover%20illustration%20of%20a%20young%20martial%20artist%20with%20fiery%20orange%20energy%20aura%20throwing%20a%20powerful%20punch%2C%20dynamic%20action%20pose%2C%20dramatic%20rim%20lighting%2C%20detailed%20ink%20linework%2C%20dark%20smoky%20background%20with%20warm%20red%20and%20amber%20energy%2C%20bold%20comic%20cover%20art%20style&width=420&height=560&seq=cover-01&orientation=portrait",
    title: "拳锋所向",
    tag: "热血动作",
    rating: "9.6",
    views: "2.8亿",
    chapter: "更新至 328 话",
    tone: "primary",
  },
  {
    cover:
      "https://readdy.ai/api/search-image?query=anime%20manga%20illustration%20of%20a%20young%20adventurer%20holding%20a%20glowing%20amber%20crystal%20staff%20before%20floating%20ancient%20ruins%20and%20a%20vast%20warm%20sky%2C%20fantasy%20comic%20cover%20art%2C%20dramatic%20golden%20light%2C%20detailed%20worldbuilding%20and%20floating%20islands&width=420&height=560&seq=cover-02&orientation=portrait",
    title: "星海旅人",
    tag: "奇幻冒险",
    rating: "9.4",
    views: "2.1亿",
    chapter: "更新至 214 话",
    tone: "accent",
  },
  {
    cover:
      "https://readdy.ai/api/search-image?query=anime%20comic%20cover%20of%20a%20stylish%20young%20man%20in%20a%20modern%20city%20at%20night%20with%20glowing%20emerald%20green%20psychic%20energy%20swirling%20around%20his%20hand%2C%20warm%20amber%20streetlights%20and%20teal%20neon%20reflections%2C%20manga%20cover%20art&width=420&height=560&seq=cover-03&orientation=portrait",
    title: "都市·异能局",
    tag: "都市异能",
    rating: "9.2",
    views: "1.6亿",
    chapter: "更新至 156 话",
    tone: "secondary",
  },
  {
    cover:
      "https://readdy.ai/api/search-image?query=dark%20mystery%20manga%20cover%20illustration%20of%20a%20detective%20silhouette%20casting%20a%20long%20shadow%20under%20warm%20amber%20lamplight%2C%20faint%20glowing%20question%20marks%20and%20fog%2C%20noir%20suspenseful%20ink%20comic%20cover%20art&width=420&height=560&seq=cover-04&orientation=portrait",
    title: "迷雾档案",
    tag: "悬疑推理",
    rating: "9.1",
    views: "1.1亿",
    chapter: "更新至 98 话",
    tone: "primary",
  },
  {
    cover:
      "https://readdy.ai/api/search-image?query=romance%20shojo%20anime%20manga%20cover%20of%20two%20high%20school%20students%20under%20a%20warm%20sunset%20with%20glowing%20coral%20and%20amber%20tones%20and%20soft%20sakura%20petals%2C%20gentle%20dreamy%20atmosphere%2C%20cute%20pastel%20manga%20cover%20art&width=420&height=560&seq=cover-05&orientation=portrait",
    title: "樱花之约",
    tag: "恋爱治愈",
    rating: "9.5",
    views: "2.4亿",
    chapter: "更新至 187 话",
    tone: "accent",
  },
  {
    cover:
      "https://readdy.ai/api/search-image?query=sci-fi%20anime%20manga%20cover%20of%20a%20massive%20mecha%20robot%20standing%20in%20a%20desert%20with%20glowing%20orange%20thrusters%20and%20heat%20haze%2C%20cinematic%20epic%20scale%2C%20dramatic%20warm%20lighting%2C%20detailed%20mechanical%20comic%20cover%20art&width=420&height=560&seq=cover-06&orientation=portrait",
    title: "苍穹机甲",
    tag: "科幻机甲",
    rating: "9.3",
    views: "1.3亿",
    chapter: "更新至 142 话",
    tone: "secondary",
  },
  {
    cover:
      "https://readdy.ai/api/search-image?query=isekai%20anime%20manga%20cover%20of%20a%20modern%20student%20teleported%20to%20a%20fantasy%20world%20with%20floating%20islands%20and%20glowing%20red-orange%20magic%20circles%2C%20epic%20scale%2C%20warm%20golden%20hour%20light%2C%20manga%20cover%20art&width=420&height=560&seq=cover-07&orientation=portrait",
    title: "异界降临",
    tag: "穿越异界",
    rating: "9.0",
    views: "1.9亿",
    chapter: "更新至 203 话",
    tone: "primary",
  },
  {
    cover:
      "https://readdy.ai/api/search-image?query=comedy%20anime%20manga%20illustration%20of%20funny%20round%20mascot%20creatures%20with%20exaggerated%20silly%20expressions%20doing%20playful%20poses%2C%20bright%20warm%20flat%20colors%2C%20cheerful%20energetic%20cartoon%20comic%20cover%20art&width=420&height=560&seq=cover-08&orientation=portrait",
    title: "日常笑料社",
    tag: "轻松搞笑",
    rating: "9.2",
    views: "2.2亿",
    chapter: "更新至 265 话",
    tone: "accent",
  },
];

export const guideSteps = [
  {
    icon: "ri-wifi-line",
    title: "先确认网络环境",
    desc: "检查当前网络是否正常，可尝试切换移动网络与 Wi-Fi 对比。若局域网或公共网络受限，可稍后或换网络重试。",
  },
  {
    icon: "ri-global-line",
    title: "清理缓存与 DNS",
    desc: "清空浏览器缓存和 DNS 缓存，或更换默认 DNS（如公共 DNS）后重新访问，可解决大部分页面打不开的情况。",
  },
  {
    icon: "ri-terminal-box-line",
    title: "尝试其它入口",
    desc: "主站临时不可用时，优先尝试本页提供的备用入口，入口状态会随访问情况更新，总有一个通道可用。",
  },
  {
    icon: "ri-error-warning-line",
    title: "避开高峰时段",
    desc: "晚间与周末为阅读高峰，服务器压力较大。若遇响应缓慢，建议稍后再试或选择移动端入口进入。",
  },
  {
    icon: "ri-restart-line",
    title: "更新收藏的链接",
    desc: "若收藏的是历史旧域名，可能已失效。请将本页展示的最新地址加入收藏，避免下次再找不到入口。",
  },
];

export const faqs = [
  {
    q: "虚空漫画网的官方入口地址是什么？",
    a: "官方主站为 www.xukongmhw.com，也是日常阅读推荐使用的入口。当主站无法打开时，可依次尝试备用入口 A（v2.xukongmhw.com）和备用入口 B（mirror.xukongmhw.com）。本页会持续同步最新可用地址，收藏本页即可随时找到入口。",
  },
  {
    q: "页面打不开，通常会是什么原因？",
    a: "常见原因包括网络环境不稳定、本地 DNS 缓存过期、旧收藏域名已更换、访问高峰导致服务器拥挤等。按本页「打开指南」中的步骤逐项排查，绝大多数情况都能恢复访问。",
  },
  {
    q: "换了网络还是进不去，怎么办？",
    a: "建议清空浏览器缓存并刷新 DNS 后重试，同时确认输入的域名没有拼写错误。若仍无法进入，可切换手机版入口（m.xukongmhw.com），或避开阅读高峰时段稍后再试。",
  },
  {
    q: "手机和电脑访问有区别吗？",
    a: "手机浏览器直接访问 m.xukongmhw.com 会自动适配屏幕，阅读体验更流畅；电脑端使用官方主站即可。两种设备都无需下载额外软件，在浏览器中打开对应地址就能开始阅读。",
  },
  {
    q: "如何判断我收藏的是不是最新地址？",
    a: "漫画站会不定期更换访问域名以保证服务稳定。若收藏链接长期无法打开，大概率是旧地址已停用。请以本页展示的最新入口为准，并把新地址加入收藏。",
  },
  {
    q: "进入后需要注册或付费吗？",
    a: "进入后可直接浏览和试读大量漫画，注册后可同步书架与追更进度，操作完全免费。如需进一步了解会员权益与功能细节，可关注站内公告，以站内最新说明为准。",
  },
];

export const testimonials = [
  {
    avatar:
      "https://readdy.ai/api/search-image?query=friendly%20portrait%20of%20a%20young%20male%20manga%20fan%20wearing%20a%20black%20hoodie%20and%20round%20glasses%2C%20warm%20studio%20lighting%2C%20soft%20cream%20background%2C%20illustration%20portrait%20style&width=200&height=200&seq=avatar-01&orientation=squarish",
    name: "阿辰",
    role: "热血漫爱好者",
    text: "追了三年《拳锋所向》，入口每次换我都靠这个页面找新地址，更新很及时，再也不怕收藏的链接打不开了。",
    star: 5,
  },
  {
    avatar:
      "https://readdy.ai/api/search-image?query=cheerful%20portrait%20of%20a%20college-age%20girl%20with%20shoulder-length%20hair%20holding%20a%20comic%20book%2C%20warm%20amber%20light%2C%20soft%20cream%20background%2C%20illustration%20portrait&width=200&height=200&seq=avatar-02&orientation=squarish",
    name: "小橘",
    role: "恋爱漫爱好者",
    text: "备用入口真的很顶，晚高峰主站卡的时候切过去一样流畅，手机版阅读体验也舒服，推荐给同样爱看漫画的朋友。",
    star: 5,
  },
  {
    avatar:
      "https://readdy.ai/api/search-image?query=smiling%20portrait%20of%20a%20man%20in%20his%20thirties%20with%20short%20hair%20and%20stubble%20wearing%20a%20casual%20shirt%2C%20warm%20natural%20light%2C%20cream%20background%2C%20illustration%20portrait&width=200&height=200&seq=avatar-03&orientation=squarish",
    name: "老周",
    role: "科幻漫爱好者",
    text: "打不开的时候照着指南清了下缓存就恢复了，步骤写得清楚，对不太会折腾网络的人很友好，收藏夹里就留了这一页。",
    star: 4,
  },
];